import { useEffect } from 'react'
import { getLanguae } from './util'
/**
 * 如果当前语言是阿拉伯语，设置文档方向为从右到左
 * 在html标签上设置dir属性 dir="rtl"
 * 其他语言文档方向为从左到右
 */


const useAraLayout = () => {
  const lang = getLanguae()

  useEffect(() => {
    const html = document.documentElement
    if (lang.startsWith('ar')) {
      html.setAttribute('dir', 'rtl')
    } else {
      html.removeAttribute('dir')
    }
  }, [lang])
}
export default useAraLayout
